var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-tooltip",
    {
      attrs: { top: "", disabled: !_vm.isDisabled },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function (ref) {
            var on = ref.on
            var attrs = ref.attrs
            return [
              _c(
                "div",
                _vm._g(
                  _vm._b(
                    { staticClass: "d-inline-block" },
                    "div",
                    attrs,
                    false
                  ),
                  on
                ),
                [
                  _c(
                    "card-dialog",
                    {
                      attrs: { width: 1200, persistent: "", transition: false },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function () {
                              return [
                                _c(
                                  "round-button",
                                  {
                                    attrs: {
                                      icon: "insert_chart",
                                      disabled: _vm.isDisabled,
                                    },
                                    on: {
                                      click: function ($event) {
                                        _vm.dialogVisible = true
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(_vm.$t("button_label")) +
                                        "\n          "
                                    ),
                                  ]
                                ),
                              ]
                            },
                            proxy: true,
                          },
                          {
                            key: "actions",
                            fn: function () {
                              return [
                                _c(
                                  "dialog-action",
                                  {
                                    staticClass: "close-button",
                                    on: { click: _vm.close },
                                  },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(_vm.$t("close")) +
                                        "\n          "
                                    ),
                                  ]
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        true
                      ),
                      model: {
                        value: _vm.dialogVisible,
                        callback: function ($$v) {
                          _vm.dialogVisible = $$v
                        },
                        expression: "dialogVisible",
                      },
                    },
                    [
                      _vm._v(" "),
                      _c("select-box", {
                        key: _vm.$i18n.locale,
                        staticClass: "insect-select-box",
                        attrs: { label: _vm.$t("insects"), items: _vm.insects },
                        model: {
                          value: _vm.insect,
                          callback: function ($$v) {
                            _vm.insect = $$v
                          },
                          expression: "insect",
                        },
                      }),
                      _vm._v(" "),
                      _vm.graphVisible
                        ? _c("bar-chart", {
                            attrs: {
                              data: _vm.chartData,
                              options: _vm.chartOptions,
                              styles: { height: "450px" },
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          },
        },
      ]),
    },
    [_vm._v(" "), _c("span", [_vm._v(_vm._s(_vm.tooltipText))])]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }